import * as React from "react";

interface SupProps {
    children: React.ReactNode;
}

export class Sup extends React.Component<SupProps> {
    public render(): JSX.Element {
        return <sup>{this.props.children}</sup>;
    }
}
